import React from 'react';
import ReactDOM from 'react-dom';
import TarotApp from './TarotApp'; // Import the TarotApp component

ReactDOM.render(<TarotApp />, document.getElementById('root'));
